export class StockIdReq{
    stockId:number;
    unitId?:number;
    constructor(stockId:number,unitId?:number){
        this.stockId = stockId;
        this.unitId =unitId;
    }
    
}